<script>
    import { entities } from "../../utils/NotificationStrings";
    import { actions } from "../../utils/NotificationStrings";

    export let content = {};
</script>

<p class="text-sm">
    {#if content.entity.type === "REACTION"}
        <b>{content.user.name}</b>

        {#if content.action !== "DELETE"}
            {actions.LIKE}
        {:else}
            {actions.REMOVE_LIKE}
        {/if}

        {entities[content.parent.type]}
    {:else if content.entity.type === "MENTION"}
        <b>{content.user.name}</b>

        {actions.MENTION}

        {entities[content.parent.type]}
    {:else}
        <b>{content.user.name}</b>

        {actions[content.action]}

        {entities[content.parent.type]}

        {entities[content.entity.type]}

        {#if content.action !== "DELETE"}
            "{content.entity.name}"
        {/if}
    {/if}
</p>

<p class="parent-entity">
    {content.parent.name}
</p>

<style>
    .parent-entity {
        @apply text-xs text-gray-400;
    }
</style>
